/**
 * SheerID Embedded Verification
 *
 * Lazy-loads SheerID verification forms when user clicks the verify button.
 */

(function () {
  const SHEERID_JS_URL =
    'https://cdn.jsdelivr.net/npm/@sheerid/jslib@2/sheerid-install.js'
  const SHEERID_BASE_URL = 'https://services.sheerid.com/verify/'

  let sheerIdModule = null

  async function loadSheerIdModule () {
    if (sheerIdModule) return sheerIdModule
    sheerIdModule = await import(SHEERID_JS_URL)
    return sheerIdModule
  }

  async function loadVerificationForm (button) {
    const programId = button.dataset.sheeridProgramId
    const containerId = button.dataset.sheeridContainerId
    const container = document.getElementById(containerId)
    const embedWrapper = button.closest('.sheerid-Embed')

    if (!container || !programId) return

    // Show loading state
    button.disabled = true
    button.textContent = 'Loading...'

    try {
      const sheerId = await loadSheerIdModule()

      // Hide button and show container
      button.hidden = true
      container.hidden = false
      button.setAttribute('aria-expanded', 'true')

      // Load the verification form
      sheerId.default.loadInlineIframe(
        container,
        `${SHEERID_BASE_URL}${programId}/`,
      )
    } catch (error) {
      console.error('Failed to load SheerID verification:', error)

      // Mark as failed to reveal fallback external link
      if (embedWrapper) {
        embedWrapper.classList.add('is-failed')
      }

      // Update button to show failure state
      button.disabled = false
      button.textContent = 'Verification unavailable - use link below'
    }
  }

  function init () {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-sheerid-trigger]')
      if (trigger) {
        event.preventDefault()
        loadVerificationForm(trigger)
      }
    })
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
